<ng-container>
  <div mat-dialog-title>
    <span>{{ title }}</span>

    <q9-dialog-close-button></q9-dialog-close-button>
  </div>

  <form #form="ngForm" (keyup.enter)="onEnterKey($event)" [formGroup]="validationForm">
    <div>
      <q9-select
        [isRequired]="true"
        formControlName="selectedType"
        [q9Track]="'CODE_SEARCH.SELECT_CODE_SEARCH_TYPE'"
        [placeholder]="'CODE_SEARCH.SELECT_TYPE_PLACEHOLDER' | translate">
        <q9-option *ngFor="let searchType of searchTypes" [value]="searchType.type">
          <span [q9Track]="'CODE_SEARCH.SELECT_CODE_SEARCH_BY_' + searchType.type">
            {{ searchType.value | translate }}
          </span>
        </q9-option>
      </q9-select>
    </div>

    <div *ngIf="selectedType.value === 'text'">
      <q9-text-field
        [isRequired]="true"
        [q9Track]="'CODE_SEARCH.TYPE_CODE_SEARCH_STRING'"
        [placeholder]="'CODE_SEARCH.TYPE_STRING_PLACEHOLDER' | translate"
        formControlName="searchValue"></q9-text-field>
      <q9-info-message *ngIf="error" type="error">{{ error | translate }}</q9-info-message>
    </div>
  </form>

  <mat-dialog-actions class="actions-panel">
    <div class="btn-container">
      <q9-secondary-button [color]="'primary'" [mat-dialog-close]="true">
        {{ 'GENERAL.CANCEL_BTN' | translate }}
      </q9-secondary-button>

      <q9-primary-button
        [color]="'primary'"
        [q9Track]="'CODE_SEARCH.RUN_CODE_SEARCH_BY_' + selectedType.value"
        (click)="form.onSubmit($event); onSubmit()">
        {{ 'CODE_SEARCH.SEARCH_BTN' | translate }}
        <mat-icon
          *ngIf="isFree"
          class="lock-btn"
          [svgIcon]="'lock'"></mat-icon>
      </q9-primary-button>
    </div>
  </mat-dialog-actions>
</ng-container>
